import React from "react";
import "../App.css"
export default function About(){
    return(<>
    <div className="about">
    <h1 style={{color:"aliceblue"}}>About Us</h1>
    <p><h4 style={{color:"rgb(206, 27, 27)"}}>Welcome to MovieADDA!</h4><br/>
At Our Movie World, we're passionate about the magic of cinema. We curate an extensive collection of films from various genres and eras, handpicking both acclaimed masterpieces and hidden gems. Dive into a world of captivating storytelling, enhanced by insightful reviews, behind-the-scenes trivia, and exclusive interviews. Join our vibrant community of movie enthusiasts, exchange recommendations, and explore the limitless possibilities of cinema. Discover the joy of movies at Our Movie World, where the silver screen is just the beginning.</p></div>
    </>);
}